import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { PopoverBody } from "reactstrap";

import FormTextField from "../../components/form/FormTextField";
import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import KeyConstants from "../../constants/keyConstants";
import { isScreenModeMobile } from "../../constants/screenModes";
import urlUtils from "../../utils/urlUtils";
import FormButton from "../form/FormButton";
import { popoverOrPortal } from "../portal/popoverOrPortal";
import InspectorField from "./InspectorField";
import InspectorRow from "./InspectorRow";

class InspectorAttachmentPopover extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      url: "",
      label: ""
    };
    this.setUrl = this.setUrl.bind(this);
    this.setLabel = this.setLabel.bind(this);
    this.onBrowseClick = this.onBrowseClick.bind(this);
    this.onAddClick = this.onAddClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  setUrl(value) {
    this.setState({ url: value });
  }

  setLabel(value) {
    this.setState({ label: value });
  }

  onBrowseClick() {
    this.props.toggle();
    this.setState({ url: "", label: "" });
    this.props.onBrowseClick();
  }

  onAddClick() {
    const { url, label } = this.state;
    if (url && urlUtils.isUrl(url)) {
      this.props.toggle();
      this.setState({ url: "", label: "" });
      return this.props.onAddClick(url, label);
    }
    this.setState({ url: "" });
  }

  onKeyDown(e) {
    switch (e.key) {
      case KeyConstants.Enter:
        this.onAddClick();
        break;
      default:
        break;
    }
  }

  renderPopoverContent() {
    let buttons = [];
    if (this.props.showBrowse) {
      buttons.push(
        <InspectorField key="browseField" className={"rightAligned"}>
          <FormButton label="Browse" onClick={this.onBrowseClick} primary={false} />
        </InspectorField>
      );
    }

    buttons.push(
      <InspectorField key="addField" className={"rightAligned"}>
        <FormButton
          label="Add"
          onClick={this.onAddClick}
          primary={this.state.url.length > 0}
          disabled={this.state.url.length == 0}
        />
      </InspectorField>
    );

    return (
      <Fragment>
        <InspectorRow label="URL">
          <InspectorField>
            <FormTextField
              isUrlField={true}
              onBlur={this.onBlur}
              onChange={this.setUrl}
              continuouslyUpdates={true}
              onEnter={this.onAddClick}
              value={this.state.url}
              //#!if iOS !== true
              autoFocus={true}
              //#!endif
            />
          </InspectorField>
        </InspectorRow>

        {this.props.label ? (
          <InspectorRow label="Title">
            <InspectorField>
              <FormTextField
                onBlur={this.onBlur}
                onChange={this.setLabel}
                continuouslyUpdates={true}
                onEnter={this.onAddClick}
                value={this.state.label}
              />
            </InspectorField>
          </InspectorRow>
        ) : null}
        <InspectorRow>{buttons}</InspectorRow>
      </Fragment>
    );
  }

  renderPopover() {
    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `inspectorPopover inspectorAttachmentPopover`,
      placement,
      hideArrow,
      isOpen: this.props.visible,
      target: this.props.target,
      toggle: this.props.toggle,
      boundariesElement: "viewport"
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.props.toggle}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>{this.renderPopoverContent()}</PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return this.props.visible ? this.renderPopover() : null;
  }
}

InspectorAttachmentPopover.propTypes = {
  visible: PropTypes.bool.isRequired,
  onBrowseClick: PropTypes.func,
  onAddClick: PropTypes.func.isRequired,
  target: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  url: PropTypes.bool,
  label: PropTypes.bool,
  title: PropTypes.string,
  backText: PropTypes.string,
  showBrowse: PropTypes.bool,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = InspectorAttachmentPopover;
//#!if iOS === true
// exportedView = withScreenContext(InspectorAttachmentPopover);
//#!endif
export default exportedView;
